import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { withStyles  } from '@mui/styles';

const styles = (/* theme */) => ({
  root: {
    textOverflow: 'ellipsis'
  },
  card: {
    position: 'absolute',
    padding: 20,
    marginTop: -70
  }
});

class CellTooltip extends Component {

  state = {
    visible: false,
    tooltipPosition: {}
  };

  constructor(props) {
    super(props);
    this.node = React.createRef();
  }

  componentDidUpdate() {
    if (this.node.current) {
      this.findTooltipPosition();
    }
  }

  updateTooltipPosition = (position) => {
    if (JSON.stringify(this.position) !== JSON.stringify(position)) {
      this.position = position;
      this.setState({ tooltipPosition: position });
    }
  }

  findTooltipPosition = () => {
    const { cell } = this.props;
    const tooltipWidth = this.node.current.getBoundingClientRect().width;
    if (!cell.current) return;
    const cellPosition = cell.current.getBoundingClientRect().left;
    if ((tooltipWidth + cellPosition) > window.innerWidth - 50) {
      const position = { left: 'auto', right: 30 };
      this.updateTooltipPosition(position);
    } else if (cellPosition < 20) {
      const position = { left: 30, right: 'auto' };
      this.updateTooltipPosition(position);
    } else {
      const position = { left: cellPosition, right: 'auto' };
      this.updateTooltipPosition(position);
    }
  }

  show = () => {
    this.wait = setTimeout(() => {
      this.setState({ visible: true });
    }, 500)
  }

  hide = () => {
    clearTimeout(this.wait);
    this.setState({ visible: false });
  }

  render() {
    const { classes, value } = this.props;
    const { visible, tooltipPosition } = this.state;

    return (
      <div
        className={classes.root}
        onMouseEnter={this.show}
        onMouseLeave={this.hide}
      >
        {visible && (
        <Card className={classes.card} style={tooltipPosition}>
          <div ref={this.node}>
            <Typography>
              {value}
            </Typography>
          </div>
        </Card>
        )}
        {value}
      </div>
    )
  }
}

CellTooltip.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired
};

export default withStyles(styles)(CellTooltip);

